function getSaler(callback) {
  let url = "https://xt-sale.betatechgroup.com/getSale";

  $.ajax({
    type: "get",
    url,
    dataType: "json",
    success: callback,
  });
}

function setSaler(obj) {
  console.log("setSaler ===>", obj);
  if (!obj) {
    return;
  }
  const last_saler = localStorage.getItem("saler_xtw");
  const { sales, code } = obj.data || {};
  if (code === 200 && !last_saler) {
    localStorage.setItem("saler_xtw", sales);
  }
}

// 上传图片
async function onUpload(e) {
  const file = e.files[0];
  if (!file) {
    return;
  }
  const uploadWrap = $("#contact-upload");
  const picWrap = $(".ymq_upload_file_item");
  const picImg = picWrap.find("img");
  const uploadLabel = $(".ymq_upload_new");
  uploadLabel.addClass("ymq-btn-progress");

  const client = new OSS({
    region: "oss-us-west-1", //你的oss地址 ，具体位置见下图
    accessKeyId: "LTAI5tC7havbcJhq4GdqLFcn", //你的ak
    accessKeySecret: "3gT45QLbmqgxHUKidtD4Gj0h6ArFqK", //你的secret
    //stsToken: '<Your securityToken(STS)>',//这里我暂时没用，注销掉
    bucket: "cikersbaseball", //你的oss名字
    secure: true,
  });

  const filename =
    "logo" + new Date().getTime() + Math.round(Math.random() * 1000);
  const res = await client.put(filename, file);
  const url = res?.url;
  uploadWrap.val(url);
  picImg.attr("src", url);
  picWrap.show();
  uploadLabel.addClass("ymq_disabled");
  uploadLabel.removeClass("ymq-btn-progress");
  uploadLabel.find("input").attr("disabled", true);
  $("#upload_del").on("click", delUpload);
}

function delUpload() {
  console.log("111=>delUpload");
  const uploadWrap = $("#contact-upload");
  const picWrap = $(".ymq_upload_file_item");
  const picImg = picWrap.find("img");
  const uploadLabel = $(".ymq_upload_new");

  uploadWrap.val("");
  picImg.removeAttr("src");
  picWrap.hide();
  uploadLabel.removeClass("ymq_disabled");
  uploadLabel.find("input").removeAttr("disabled").val("");
}

function initTeamColor() {
  console.log("initTeamColor ==>", 111);
  let result = {};
  $(".checkbox_input").on("click", function () {
    const id = $(this).attr("id");
    const val = $(this).val();
    if (!result[id]) {
      result[id] = val;
    } else {
      result[id] = "";
    }
    const values = Object.values(result).filter((item) => item);
    $("#ContactForm #TeamColor").val(values.join(","));
    console.log("initTeamColor result values==>", result, values);
  });
}

// 'jimmy':{
//       'action_add': 'https://formspree.io/f/xrgrazla',
//       'numbers': '8613640280322',
//       'messeger': '100009280718259'
//     },
//     'ShirleyZ':{
//       'action_add': 'https://formspree.io/f/mzbkpepr',
//       'numbers': '8618650715681',
//       'messeger': '100014276466069'
//     },
//     'Shirley':{
//       'action_add': 'https://formspree.io/f/xbjwzorr',
//       'numbers': '8615169990690',
//       'messeger': '100050118410651'
//     },
//     'Fuson':{
//       'action_add': 'https://formspree.io/f/mzbowqqp',
//       'numbers': '8615820233193',
//       'messeger': '100082241630467'
//     },

const testaction = "https://formspree.io/f/xpzvenvk";
// 这里是 formspree
const saleman_action = {
  Fuson: "https://formspree.io/f/mzbowqqp",
  Shirley: "https://formspree.io/f/xbjwzorr",
  jimmy: "https://formspree.io/f/xrgrazla",
  ShirleyZ: "https://formspree.io/f/mzbkpepr",
  Leo: "https://formspree.io/f/mgvyepgg",
  Iris: "https://formspree.io/f/xgedlnjq"
};
// 这里是 WhatsApp
const saleman_what_no = {
  Fuson: "8615820233193",
  Shirley: "8615169990690",
  jimmy: "8613640280322",
  ShirleyZ: "85294239727",
  Leo: "8617813324969",
  Iris: "8615137818380"
};

function handleWhats() {
  const saler = localStorage.getItem("saler_xtw");
  let numbers = saleman_what_no[saler];
  let whaturl = "https://wa.me/" + numbers;
  let whatapi = "https://api.whatsapp.com/send?phone=" + numbers;
  // window.open(whaturl);
  // setTimeout(function () {
  window.open(whatapi);
  // }, 2000)
}

function openWhats() {
  // fbq("track", "Contact");
  handleWhats();
}

const numberReg = /^\d{9,}$/;

function scrollFormTop() {
  const contactform = document.getElementById("formtop");
  contactform.scrollIntoView();
}

function checkForm() {
  const name = $(".contact-form__form input[name='contact[Name]']");
  const email = $(".contact-form__form input[name='contact[email]']");
  // const phone = $(".contact-form__form input[name='contact[Phone]']");
  const whatsApp = $(
    ".contact-form__form input[name='contact[WhatsApp Number / Phone]']"
  );
  const errorTip = $("#error-tip");
  const errorWrap = $(".form-error-status");
  if (!name.val()) {
    errorWrap.show();
    errorTip.html("name is invalid!");
    // errorTip.attr("href", "#ContactForm-name");
    scrollFormTop();
    return false;
  }
  if (!email.val()) {
    errorWrap.show();
    errorTip.html("email is invalid!");
    // errorTip.attr("href", "#ContactForm-email");
    scrollFormTop();
    return false;
  }
  // if (!phone.val()) {
  //   errorWrap.show();
  //   errorTip.html("phone is invalid!");
  //   // errorTip.attr("href", "#ContactForm-phone");
  //   scrollFormTop();
  //   return false;
  // }
  if (whatsApp && !whatsApp.val()) {
    errorWrap.show();
    errorTip.html("WhatsApp Number / Phone is invalid!");
    // errorTip.attr("href", "#ContactForm-whatsApp");
    scrollFormTop();
    return false;
  }

  return true;
}

function btnloading(flag) {
  const btn = $("#contact_submit");
  if (flag) {
    btn.addClass("loading");
  } else {
    btn.removeClass("loading");
  }
}

// data 销售名称
// 初始化时表单action地址为销售询盘地址
// 初始化广告来源 location.href
function initFormAction(data) {
  btnloading(true);
  const { sales, code } = data.data || {};
  //   写入ad_source
  const contactform = $(".contact-form__form");
  const ad_source = location.href;
  if (
    location.href.indexOf("utm_source") != -1 ||
    location.href.indexOf("gclid") != -1
  ) {
    $("#ad_source").val(ad_source);
  }

  const lastsaler = localStorage.getItem("saler_xtw");
  const action = sales ? saleman_action[sales] : saleman_action[lastsaler];
  const submitbtn = document.getElementById("contact_submit");
  if (!action) {
    return;
  }
  contactform.find("input[name='form_type']").val(location.href);
  contactform.find("input[name='utf8']").remove();
  contactform.find("input[name='form_key']").remove();
  
  $(submitbtn).on("click", function (e) {
    e.preventDefault();
    const isvalid = checkForm();
    if (!isvalid) {
      // btnloading(false);
      return;
    }

    // handleBackup(contactform[0]);
    contactform.attr("action", action);
    contactform.attr("disable", true);
    contactform.submit();
  });
}

function initSaler(data) {
  setSaler(data);
  initFormAction(data);
}

$(document).ready(function () {
  initTeamColor();
  getSaler(initSaler);
});
